(function () {
  'use strict';

  var theme = window.WagmadeTheme;
  if (!theme) return;

  function focusableElements(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter(function (element) {
      return !element.hidden && element.getAttribute('aria-hidden') !== 'true';
    });
  }

  function createPreviewLinkNormalizer(root) {
    var observer;
    var localHosts = ['localhost', '127.0.0.1'];
    var shopHosts = [root.dataset.wmShopDomain, root.dataset.wmShopPrimaryHost, root.dataset.wmShopPermanentHost]
      .filter(Boolean)
      .map(function (host) { return host.toLowerCase(); });

    function isLocalPreview() {
      return localHosts.indexOf(window.location.hostname.toLowerCase()) !== -1;
    }

    function normalizeAnchor(anchor) {
      if (!isLocalPreview() || !anchor || !anchor.href) return;

      var parsed;
      try {
        parsed = new URL(anchor.href, window.location.href);
      } catch (error) {
        return;
      }

      if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return;
      if (shopHosts.indexOf(parsed.hostname.toLowerCase()) === -1) return;
      anchor.setAttribute('href', parsed.pathname + parsed.search + parsed.hash);
    }

    function normalizeTree(scope) {
      if (!isLocalPreview() || !scope) return;
      if (scope.matches && scope.matches('a[href]')) normalizeAnchor(scope);
      if (scope.querySelectorAll) {
        scope.querySelectorAll('a[href]').forEach(normalizeAnchor);
      }
    }

    return {
      init: function () {
        if (!isLocalPreview() || !shopHosts.length) return;
        normalizeTree(root);
        observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
              if (node.nodeType === 1) normalizeTree(node);
            });
          });
        });
        observer.observe(root, { childList: true, subtree: true });
      },
      refresh: function () {
        normalizeTree(root);
      },
      destroy: function () {
        if (observer) observer.disconnect();
        observer = null;
      },
    };
  }

  function createHeader(root) {
    var headerShell = root.querySelector('[data-header-shell]') || root;
    var listenerController;
    var requestController;
    var closeTimer;
    var searchTimer;
    var activePanel;
    var activeTrigger;
    var previousFocus;
    var previousBodyOverflow;
    var backgroundState = [];
    var lastScrollY = window.scrollY;
    var scrollFrame;
    var movementRoot;
    var movementActive = false;
    var motionQuery;
    var layoutQuery;
    var desktopQuery;
    var mobileQuery;
    var capabilityChangeHandler;
    var hideTimer;
    var upwardIntent = 0;
    var downwardIntent = 0;

    function signal() {
      return listenerController.signal;
    }

    function cancelHeaderHide() {
      if (!hideTimer) return;
      window.clearTimeout(hideTimer);
      hideTimer = null;
    }

    function setHeaderVisible() {
      cancelHeaderHide();
      if (headerShell.getAttribute('data-hidden') !== ('false')) headerShell.setAttribute('data-hidden', 'false');
    }

    function setHeaderHidden() {
      cancelHeaderHide();
      headerShell.setAttribute('data-hidden', 'true');
    }

    function clearHeaderImmersiveState() {
      cancelHeaderHide();
      movementActive = false;
      upwardIntent = 0;
      downwardIntent = 0;
      if (headerShell.getAttribute('data-hidden') !== ('false')) headerShell.setAttribute('data-hidden', 'false');
      headerShell.removeAttribute('data-wm-header-immersive');
    }

    function movementBounds() {
      var nextMovementRoot = root.ownerDocument.querySelector('[data-wm-home-movement]');
      if (nextMovementRoot !== movementRoot) {
        movementRoot = nextMovementRoot;
        movementActive = false;
        upwardIntent = 0;
        downwardIntent = 0;
      }
      if (!movementRoot) return null;

      var movementRect = movementRoot.getBoundingClientRect();
      var headerHeight = Math.max(headerShell.getBoundingClientRect().height || 44, 44);
      var enterLine = headerHeight + 20;
      var exitLine = headerHeight + 28;
      var active = movementRect.top <= enterLine && movementRect.bottom > exitLine;
      var entered = active && !movementActive;
      if (active !== movementActive) {
        movementActive = active;
        upwardIntent = 0;
        downwardIntent = 0;
      }
      return {
        active: active,
        entered: entered,
      };
    }

    function immersiveHeaderAllowed() {
      return Boolean(
        desktopQuery && desktopQuery.matches &&
        motionQuery && !motionQuery.matches
      );
    }

    function mobileHeaderAllowed() {
      return Boolean(mobileQuery && mobileQuery.matches);
    }

    function syncMobileHeader() {
      if (!mobileHeaderAllowed()) return;
      // Mobile navigation stays available in both scroll directions.
      clearHeaderImmersiveState();
    }

    function scheduleHeaderHide() {
      if (hideTimer || headerShell.getAttribute('data-hidden') === 'true') return;
      hideTimer = window.setTimeout(function () {
        hideTimer = null;
        var bounds = movementBounds();
        if (!bounds || !bounds.active || bounds.entered || activePanel || activeTrigger || upwardIntent > 0) return;
        headerShell.setAttribute('data-hidden', 'true');
      }, 160);
    }

    function syncHeaderImmersive(direction, delta) {
      var bounds = movementBounds();
      if (!bounds || !bounds.active || !immersiveHeaderAllowed()) {
        clearHeaderImmersiveState();
        return;
      }

      headerShell.setAttribute('data-wm-header-immersive', 'movement');
      if (bounds.entered) {
        if (activePanel || activeTrigger) {
          setHeaderVisible();
        } else if (direction < 0 || direction === 0) {
          // Returning from below should enter the Movement photography without restoring the rail.
          setHeaderHidden();
        } else {
          setHeaderVisible();
        }
        return;
      }
      if (activePanel || activeTrigger) {
        setHeaderVisible();
        return;
      }

      if (direction > 0) {
        downwardIntent += Math.abs(delta);
        upwardIntent = 0;
        if (downwardIntent >= 72) scheduleHeaderHide();
        return;
      }

      if (direction < 0) {
        cancelHeaderHide();
        upwardIntent += Math.abs(delta);
        downwardIntent = 0;
        // The rail stays out of the Movement composition in either scroll direction.
        setHeaderHidden();
      }
    }

    function revealHeaderAtTop(event) {
      if ((!immersiveHeaderAllowed() && !mobileHeaderAllowed()) || event.clientY > 28) return;
      if (headerShell.getAttribute('data-hidden') === 'true') setHeaderVisible();
    }

    function setHeaderScrollState(state) {
      if (headerShell.getAttribute('data-scroll-state') !== state) headerShell.setAttribute('data-scroll-state', state);
    }

    function syncHeaderScroll() {
      var currentY = window.scrollY;
      if (headerShell.getAttribute('data-at-page-top') !== (currentY < 8 ? 'true' : 'false')) headerShell.setAttribute('data-at-page-top', currentY < 8 ? 'true' : 'false');
      var delta = currentY - lastScrollY;
      var direction = delta > 0 ? 1 : delta < 0 ? -1 : 0;

      if (direction) {
        if (headerShell.getAttribute('data-scroll-direction') !== (direction > 0 ? 'down' : 'up')) headerShell.setAttribute('data-scroll-direction', direction > 0 ? 'down' : 'up');
      }

      if (headerShell.getAttribute('data-shrink') !== (currentY > 100 ? 'true' : 'false')) headerShell.setAttribute('data-shrink', currentY > 100 ? 'true' : 'false');
      setHeaderScrollState(currentY > 72 ? 'scrolled' : 'top');

      if (currentY < 8) {
        headerShell.setAttribute('data-scroll-direction', 'top');
        setHeaderScrollState('top');
        clearHeaderImmersiveState();
      } else if (mobileHeaderAllowed()) {
        syncMobileHeader(direction, delta, currentY);
      } else {
        syncHeaderImmersive(direction, delta);
      }

      lastScrollY = currentY;
    }

    function scheduleHeaderScroll() {
      if (scrollFrame) return;

      scrollFrame = window.requestAnimationFrame(function () {
        scrollFrame = null;
        syncHeaderScroll();
      });
    }

    function cancelMegaClose() {
      if (!closeTimer) return;
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    function closeMega(options) {
      cancelMegaClose();
      root.querySelectorAll('[data-mega-trigger]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.removeAttribute('data-mega-open');
      });
      root.querySelectorAll('[data-mega-panel]').forEach(function (panel) {
        panel.hidden = true;
      });
      if (options && options.restoreFocus && activeTrigger) activeTrigger.focus();
      activeTrigger = null;
    }

    function openMega(trigger) {
      var key = trigger.getAttribute('data-mega-trigger');
      var panel = root.querySelector('[data-mega-panel="' + key + '"]');
      if (!panel) return;

      closeMega();
      closePanel({ restoreFocus: false });
      activeTrigger = trigger;
      trigger.setAttribute('aria-expanded', 'true');
      trigger.setAttribute('data-mega-open', 'true');
      panel.hidden = false;
      setHeaderVisible();
    }

    function toggleMega(trigger) {
      var key = trigger.getAttribute('data-mega-trigger');
      var panel = root.querySelector('[data-mega-panel="' + key + '"]');
      if (!panel) return;
      if (activeTrigger === trigger && !panel.hidden) {
        closeMega();
      } else {
        openMega(trigger);
      }
    }

    function isMegaInteractionActive() {
      var focused = document.activeElement;
      var focusWithinMega = focused && root.contains(focused) && focused.closest('[data-mega-trigger], [data-mega-panel]');
      return Boolean(
        root.querySelector('[data-mega-trigger]:hover') ||
        root.querySelector('[data-mega-panel]:not([hidden]):hover') ||
        focusWithinMega
      );
    }

    function scheduleMegaClose() {
      cancelMegaClose();
      closeTimer = window.setTimeout(function () {
        closeTimer = null;
        if (isMegaInteractionActive()) return;
        closeMega();
      }, 240);
    }

    function lockBackground() {
      previousBodyOverflow = document.body.style.overflow;
      var backgroundNodes = [
        document.querySelector('#MainContent'),
        document.querySelector('[data-wm-footer]'),
      ].filter(Boolean);

      backgroundState = backgroundNodes.map(function (node) {
        var state = {
          node: node,
          inert: node.inert,
          ariaHidden: node.getAttribute('aria-hidden'),
        };
        node.inert = true;
        node.setAttribute('aria-hidden', 'true');
        return state;
      });

      document.body.style.overflow = 'hidden';
      document.body.dataset.wmLock = 'true';
    }

    function unlockBackground() {
      document.body.style.overflow = previousBodyOverflow || '';
      delete document.body.dataset.wmLock;
      backgroundState.forEach(function (state) {
        state.node.inert = state.inert;
        if (state.ariaHidden === null) state.node.removeAttribute('aria-hidden');
        else state.node.setAttribute('aria-hidden', state.ariaHidden);
      });
      backgroundState = [];
    }

    function positionSearchPanel(trigger, panel) {
      if (!trigger || !panel) return;
      var bounds = trigger.getBoundingClientRect();
      var navigation = headerShell.querySelector('.wagmade-header__nav');
      var navigationRight = navigation ? navigation.getBoundingClientRect().right : 0;
      var availableWidth = bounds.right - navigationRight - 16;
      panel.style.setProperty('--wm-search-top', Math.max(8, bounds.top - 2) + 'px');
      panel.style.setProperty('--wm-search-right', Math.max(16, window.innerWidth - bounds.right) + 'px');
      panel.style.setProperty('--wm-search-width', Math.max(180, Math.min(400, availableWidth)) + 'px');
    }

    function closePanel(options) {
      if (!activePanel) return;
      var wasModal = activePanel.getAttribute('data-panel') === 'menu';
      activePanel.hidden = true;
      root.querySelectorAll('[data-panel-toggle]').forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      });
      activePanel = null;
      if (wasModal) unlockBackground();
      if (!options || options.restoreFocus !== false) {
        if (previousFocus && previousFocus.focus) previousFocus.focus({ preventScroll: true });
      }
      previousFocus = null;
    }

    function openPanel(name, trigger) {
      var panel = root.querySelector('[data-panel="' + name + '"]');
      if (!panel) return;
      if (activePanel === panel) {
        closePanel();
        return;
      }

      closeMega();
      closePanel({ restoreFocus: false });
      previousFocus = trigger || document.activeElement;
      activePanel = panel;
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      setHeaderVisible();
      if (name === 'menu') lockBackground();
      else if (name === 'search') positionSearchPanel(trigger, panel);

      var target = panel.querySelector('[data-autofocus]') || focusableElements(panel)[0];
      if (target) target.focus({ preventScroll: true });
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        if (activePanel) {
          event.preventDefault();
          closePanel();
          return;
        }
        if (activeTrigger) {
          event.preventDefault();
          closeMega({ restoreFocus: true });
        }
        return;
      }

      if (!activePanel || activePanel.getAttribute('data-panel') !== 'menu' || event.key !== 'Tab') return;
      var focusable = focusableElements(activePanel);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function renderPredictiveSearch(input) {
      var container = root.querySelector('[data-predictive-results]');
      var endpoint = input.getAttribute('data-predictive-url');
      var query = input.value.trim();
      if (!container || !endpoint) return;

      if (requestController) requestController.abort();
      if (!query) {
        container.innerHTML = '';
        container.removeAttribute('data-loading');
        return;
      }

      requestController = new AbortController();
      container.setAttribute('data-loading', 'true');
      var resourceTypes = input.getAttribute('data-predictive-types') || 'product,collection,page';
      var url = endpoint + '?q=' + encodeURIComponent(query) + '&resources[type]=' + encodeURIComponent(resourceTypes) + '&resources[limit]=6&section_id=predictive-search';

      fetch(url, { signal: requestController.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Predictive search request failed');
          return response.text();
        })
        .then(function (markup) {
          var parsed = new DOMParser().parseFromString(markup, 'text/html');
          var section = parsed.querySelector('#shopify-section-predictive-search');
          container.innerHTML = section ? section.innerHTML : '';
          container.removeAttribute('data-loading');
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          container.removeAttribute('data-loading');
          container.innerHTML = '<p class="wagmade-predictive-search__status" role="status">' +
            (container.getAttribute('data-error-message') || '') +
            '</p>';
        });
    }

    function bind() {
      listenerController = new AbortController();
      root.querySelectorAll('[data-panel-toggle]').forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          if (trigger.tagName === 'A') event.preventDefault();
          openPanel(trigger.getAttribute('data-panel-toggle'), trigger);
        }, { signal: signal() });
        if (trigger.tagName === 'A') {
          trigger.addEventListener('keydown', function (event) {
            if (event.key !== ' ') return;
            event.preventDefault();
            openPanel(trigger.getAttribute('data-panel-toggle'), trigger);
          }, { signal: signal() });
        }
      });
      root.querySelectorAll('[data-panel-close]').forEach(function (closer) {
        closer.addEventListener('click', function () {
          closePanel();
        }, { signal: signal() });
      });
      root.querySelectorAll('[data-panel-dismiss]').forEach(function (panel) {
        panel.addEventListener('click', function (event) {
          if (event.target === panel) closePanel();
        }, { signal: signal() });
      });
      document.addEventListener('pointerdown', function (event) {
        if (!activePanel || activePanel.getAttribute('data-panel') !== 'search') return;
        if (activePanel.contains(event.target) || (previousFocus && previousFocus.contains(event.target))) return;
        closePanel({ restoreFocus: false });
      }, { signal: signal() });
      root.querySelectorAll('[data-mega-trigger]').forEach(function (trigger) {
        trigger.addEventListener('mouseenter', function () {
          cancelMegaClose();
          openMega(trigger);
        }, { signal: signal() });
        trigger.addEventListener('mouseleave', scheduleMegaClose, { signal: signal() });
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          var panel = root.querySelector('[data-mega-panel]:not([hidden])');
          if (!panel || activeTrigger !== trigger) openMega(trigger);
        }, { signal: signal() });
        trigger.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleMega(trigger);
            return;
          }
          if (event.key !== 'ArrowDown') return;
          event.preventDefault();
          openMega(trigger);
          var panel = root.querySelector('[data-mega-panel]:not([hidden])');
          var firstLink = panel && panel.querySelector('a');
          if (firstLink) firstLink.focus();
        }, { signal: signal() });
      });
      root.querySelectorAll('[data-nav-wrapper], [data-mega-panel]').forEach(function (element) {
        element.addEventListener('mouseenter', cancelMegaClose, { signal: signal() });
        element.addEventListener('mouseleave', scheduleMegaClose, { signal: signal() });
      });

      var searchInput = root.querySelector('[data-predictive-input]');
      if (searchInput) {
        searchInput.addEventListener('input', function () {
          window.clearTimeout(searchTimer);
          if (!searchInput.value.trim()) {
            renderPredictiveSearch(searchInput);
            return;
          }
          searchTimer = window.setTimeout(function () {
            renderPredictiveSearch(searchInput);
          }, 180);
        }, { signal: signal() });
        var searchClear = root.querySelector('[data-search-clear]');
        if (searchClear) {
          searchClear.addEventListener('click', function () {
            searchInput.value = '';
            searchInput.dispatchEvent(new Event('input', { bubbles: true }));
            searchInput.focus();
          }, { signal: signal() });
        }
      }

      var mobileSearch = root.querySelector('.wagmade-mobile-search');
      if (mobileSearch) {
        mobileSearch.addEventListener('reset', function () {
          window.requestAnimationFrame(function () {
            var input = mobileSearch.querySelector('input[type="search"]');
            if (input) input.focus();
          });
        }, { signal: signal() });
      }

      root.addEventListener('focusout', function (event) {
        var megaBoundary = event.target.closest('[data-mega-trigger], [data-mega-panel]');
        if (!megaBoundary) return;
        var nextTarget = event.relatedTarget;
        if (nextTarget && root.contains(nextTarget) && nextTarget.closest('[data-mega-trigger], [data-mega-panel]')) return;
        closeMega();
      }, { signal: signal() });
      document.addEventListener('keydown', onKeydown, { signal: signal() });
      root.addEventListener('focusin', setHeaderVisible, { signal: signal() });
      document.addEventListener('focusin', function (event) {
        if (!activePanel || activePanel.getAttribute('data-panel') !== 'search') return;
        if (activePanel.contains(event.target) || event.target === previousFocus) return;
        closePanel({ restoreFocus: false });
      }, { signal: signal() });
      document.addEventListener('pointermove', revealHeaderAtTop, { passive: true, signal: signal() });
      window.addEventListener('scroll', scheduleHeaderScroll, { passive: true, signal: signal() });
      window.addEventListener('scroll', function () {
        if (activePanel && activePanel.getAttribute('data-panel') === 'search') closePanel({ restoreFocus: false });
      }, { passive: true, signal: signal() });
      window.addEventListener('resize', function () {
        if (activePanel && activePanel.getAttribute('data-panel') === 'search') positionSearchPanel(previousFocus, activePanel);
      }, { passive: true, signal: signal() });

      motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      layoutQuery = window.matchMedia('(min-width: 1024px)');
      desktopQuery = window.matchMedia('(min-width: 1024px)');
      mobileQuery = window.matchMedia('(max-width: 700px), (max-width: 1023px) and (orientation: portrait)');
      capabilityChangeHandler = function () {
        upwardIntent = 0;
        downwardIntent = 0;
        syncHeaderScroll();
      };
      if (motionQuery.addEventListener) motionQuery.addEventListener('change', capabilityChangeHandler, { signal: signal() });
      else if (motionQuery.addListener) motionQuery.addListener(capabilityChangeHandler);
      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', capabilityChangeHandler, { signal: signal() });
      else if (mobileQuery.addListener) mobileQuery.addListener(capabilityChangeHandler);
      layoutQuery.addEventListener('change', function (event) {
        if (event.matches && activePanel && activePanel.getAttribute('data-panel') === 'menu') closePanel();
      }, { signal: signal() });
      desktopQuery.addEventListener('change', function () {
        closeMega();
        capabilityChangeHandler();
      }, { signal: signal() });
      syncHeaderScroll();
    }

    return {
      init: bind,
      refresh: function () {
        syncHeaderScroll();
      },
      destroy: function () {
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        window.clearTimeout(closeTimer);
        window.clearTimeout(searchTimer);
        if (requestController) requestController.abort();
        closeMega();
        closePanel({ restoreFocus: false });
        if (motionQuery && capabilityChangeHandler && motionQuery.removeListener) {
          motionQuery.removeListener(capabilityChangeHandler);
        }
        if (mobileQuery && capabilityChangeHandler && mobileQuery.removeListener) {
          mobileQuery.removeListener(capabilityChangeHandler);
        }
        clearHeaderImmersiveState();
        movementRoot = null;
        movementActive = false;
        motionQuery = null;
        layoutQuery = null;
        desktopQuery = null;
        mobileQuery = null;
        capabilityChangeHandler = null;
        if (listenerController) listenerController.abort();
      },
    };
  }

  function createFooter(root) {
    var listenerController;

    function syncDetails() {
      var desktop = window.matchMedia('(min-width: 769px)').matches;
      root.querySelectorAll('[data-footer-details]').forEach(function (details) {
        details.open = desktop;
      });
    }

    return {
      init: function () {
        listenerController = new AbortController();
        var desktopQuery = window.matchMedia('(min-width: 769px)');
        desktopQuery.addEventListener('change', syncDetails, { signal: listenerController.signal });
        syncDetails();
      },
      refresh: syncDetails,
      destroy: function () {
        if (listenerController) listenerController.abort();
      },
    };
  }

  function createStoryTone(root) {
    var listenerController;
    var animationFrame;
    var chapters = [];
    var hero;
    var stateRoot = document.documentElement;

    function syncChapters() {
      delete stateRoot.dataset.wmStoryChapter;
      chapters = Array.prototype.slice.call(root.querySelectorAll('[data-wm-story-chapter]'));
      hero = root.querySelector('[data-wm-home-hero]');
    }

    function update() {
      animationFrame = null;
      // Batch geometry reads before any attributes invalidate style/layout.
      var heroPassed = hero ? hero.getBoundingClientRect().bottom <= 0 : null;
      var marker = Math.min(window.innerHeight * 0.4, 360);
      var activeIndex = 0;
      chapters.forEach(function (chapter, index) {
        if (chapter.getBoundingClientRect().top <= marker) activeIndex = index;
      });
      if (hero) {
        var passed = heroPassed ? 'true' : 'false';
        if (stateRoot.dataset.wmHeroPassed !== passed) stateRoot.dataset.wmHeroPassed = passed;
      } else delete stateRoot.dataset.wmHeroPassed;
      if (!chapters.length) {
        delete stateRoot.dataset.wmStoryTone;
        delete stateRoot.dataset.wmStoryChapter;
        return;
      }
      var active = chapters[activeIndex];
      var tone = active.dataset.storyTone || 'light';
      if (stateRoot.dataset.wmStoryTone !== tone) stateRoot.dataset.wmStoryTone = tone;
      if (stateRoot.dataset.wmStoryChapter !== String(activeIndex + 1)) {
        stateRoot.dataset.wmStoryChapter = String(activeIndex + 1);
        chapters.forEach(function (chapter, index) {
          chapter.dataset.storyActive = index === activeIndex ? 'true' : 'false';
        });
      }
    }

    function requestUpdate() {
      if (animationFrame) return;
      animationFrame = window.requestAnimationFrame(update);
    }

    function clearState() {
      delete stateRoot.dataset.wmHeroPassed;
      if (animationFrame) window.cancelAnimationFrame(animationFrame);
      animationFrame = null;
      chapters.forEach(function (chapter) {
        delete chapter.dataset.storyActive;
      });
      delete stateRoot.dataset.wmStoryTone;
      delete stateRoot.dataset.wmStoryChapter;
    }

    return {
      init: function () {
        if (listenerController) listenerController.abort();
        listenerController = new AbortController();
        syncChapters();
        window.addEventListener('scroll', requestUpdate, { passive: true, signal: listenerController.signal });
        window.addEventListener('resize', requestUpdate, { passive: true, signal: listenerController.signal });
        update();
      },
      refresh: function () {
        syncChapters();
        update();
      },
      destroy: function () {
        if (listenerController) listenerController.abort();
        listenerController = null;
        clearState();
      },
    };
  }

  theme.register('preview-links', '[data-wm-preview-links]', createPreviewLinkNormalizer);
  theme.register('header', '[data-wm-header]', createHeader);
  theme.register('footer', '[data-wm-footer]', createFooter);
  theme.register('story-tone', '#MainContent', createStoryTone);

  function start() {
    theme.init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
